
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CreditTransaction } from "@/hooks/useTransactions";

interface CreditHistoryProps {
  transactions: CreditTransaction[];
}

const CreditHistory = ({ transactions }: CreditHistoryProps) => {
  // Group transactions by type
  const purchases = transactions.filter(t => t.type === 'purchase');
  const usages = transactions.filter(t => t.type === 'usage');
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Credit History</CardTitle>
        <CardDescription>Your credit purchases and usage history</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          <div>
            <h3 className="text-lg font-medium mb-2">Purchases</h3>
            {purchases.length === 0 ? (
              <p className="text-gray-500 text-sm">No purchase history yet.</p>
            ) : (
              <div className="space-y-2">
                {purchases.map((transaction) => (
                  <div 
                    key={transaction.id}
                    className="flex justify-between items-center border-b pb-2"
                  >
                    <div>
                      <p className="font-medium text-green-700">+{transaction.amount} credits</p>
                      <p className="text-sm text-gray-600">{transaction.description}</p>
                    </div>
                    <div className="text-sm text-gray-500">
                      {new Date(transaction.date).toLocaleDateString()}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-2">Usage</h3>
            {usages.length === 0 ? (
              <p className="text-gray-500 text-sm">No usage history yet.</p>
            ) : (
              <div className="space-y-2">
                {usages.map((transaction) => (
                  <div 
                    key={transaction.id}
                    className="flex justify-between items-center border-b pb-2"
                  >
                    <div>
                      <p className="font-medium text-red-700">-{transaction.amount} credit</p>
                      <p className="text-sm text-gray-600">{transaction.description}</p>
                    </div>
                    <div className="text-sm text-gray-500">
                      {new Date(transaction.date).toLocaleDateString()}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CreditHistory;
